export default {
  quantities: [4, 10, 50, 100],
  lead_times: ['1US', '2US', '3US', '4US', '5US'],
  matrix    : {
    '4' : {
      'grpb': {
        '1US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '2US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '3US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '4US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '5US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
      },
    },
    '10' : {
      'grpb': {
        '1US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '2US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '3US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '4US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '5US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
      },
    },
    '50' : {
      'grpb': {
        '1US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '2US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '3US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '4US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '5US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
      },
    },
    '100': {
      'grpb': {
        '1US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '2US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '3US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '4US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
        '5US': {
          quantity        : 10,
          total           : 0,
          lead_time       : 1,
          product_key     : 'fabrication-us-quickturn',
          quote_config_key: 'plx-grpb',
          row_line_item   : 0,
          col_line_item   : 0,
        },
      },
    },
  },
}
